<li class="mar-btm" style="list-style:none">
    <div class="media-left" *ngIf="!isResponse">
        <img src="./assets/img/you.png" class="img-circle img-sm" alt="Profile Picture">
    </div>
    <div class="media-body pad-hor"
     *ngIf="!isResponse">
        <div class="speech" 
        style="box-shadow:0px 0px 3px 1px #ccc;">
            <a href="#" class="media-heading" style="font-weight: bold;">{{userName}}</a>
            <p>{{inputMessage}}</p>
            <p>{{inputMessage2}}</p>
            <p class="speech-time">
                <i class="fa fa-clock-o fa-fw"></i>&nbsp;&nbsp;{{sendTime}}
            </p>
        </div>
    </div>

    <div class="media-right" style="float: right; margin-right: 15px;" *ngIf="isResponse">
        <img src="./assets/img/jacky.png" class="img-circle img-sm" alt="Profile Picture">
    </div>
    <div class="media-body pad-hor speech-right" *ngIf="isResponse">
        <div class="speech" 
        style="box-shadow:0px 0px 3px 1px #ccc;">
            <a href="#" class="media-heading" style="font-weight: bold;">{{userName}}</a>
            <p>{{inputMessage}}</p>
            <p class="speech-time">
                <i class="fa fa-clock-o fa-fw"></i>&nbsp;&nbsp;{{sendTime}}
            </p>
            <p [innerHTML]="debugMessage"></p>
        </div>
    </div>
</li>